module.exports = __webpack_public_path__ + "assets/img/tsgn4.5084590f.jpg";